/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */
import { getActualKey } from '@oat-sa-private/ui-core';

/**
 * Svelte Action to prevent scroll-on-space within a given element
 *
 * @example
 * <div tabindex="0" use:preventSpaceScroll />
 *
 * @param {HTMLElement} node - node capturing the keydown events
 * @returns {Object} - node's lifecycle hooks
 */
export default function preventSpaceScroll(node) {
    /**
     * Handle space key
     * @param {KeyboardEvent} event
     */
    function handleKeyDown(event) {
        const pressedKey = getActualKey(event);
        if (pressedKey === 'space') {
            event.preventDefault();
        }
    }

    // Initialise the listener
    node.addEventListener('keydown', handleKeyDown);

    return {
        /**
         * Hook on component lifecyle: remove listener
         */
        destroy() {
            node.removeEventListener('keydown', handleKeyDown);
        }
    };
}
